import { bridge } from '@didi/webx-js';
import { isDdPassengerH5 } from '@/common/constant';
const choose = () => {
  return new Promise(async (resolve, reject) => {
    if (isDdPassengerH5) {
      const res = await openPhoto();
      console.log('res is', res);
      res.photograph_result === 0 &&
        resolve({
          urls: handleInput(res.image)
        }); 
    } else {
      let input = document.createElement('input');
      input.type = 'file';
      input.accept = 'image/jpg,image/jpeg,image/png';
      input.multiple = true;
      input.style.display = 'none';
      document.body.appendChild(input);
      input.onchange = async function(e) {
        const { files: list } = e.target;
        const files = [];
        const urls = [];
        for (let file of list) {
          files.push(file);
          let previewUrl = await getPreviewUrl(file);
          urls.push(previewUrl);
        }
        resolve({
          files,
          urls
        });
        document.body.removeChild(input);
        input = null;
      };
      input.click();
    }
  });
};

const getPreviewUrl = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function (e) {
      // 读取到的图片 base64 数据编码 将此编码字符串传给后台即可
      let imgBase64Code = e.target.result;
      // // 截取头部信息。统一 jpeg 显示
      // imgBase64Code = imgBase64Code.replace(/^data:image\/\w+;base64,/, '')
      if (imgBase64Code && imgBase64Code.indexOf("data:base64,") !== -1) {
        // 去除旧有的错误头部
        imgBase64Code = imgBase64Code.replace("data:base64,", "");
        const dataType = "";
        // 文件名字
        const name = file.name;
        if (name && name.toLowerCase().indexOf(".jpg") !== -1) {
          // jpeg
          dataType = "image/jpeg";
        } else if (name && name.toLowerCase().indexOf(".png") !== -1) {
          // png
          dataType = "image/png";
        }
        imgBase64Code = "data:" + dataType + ";base64," + imgBase64Code;
      }
      resolve(imgBase64Code);
    };
    reader.onerror = function (err) {
      reject(err);
    };
  });
};


const handleInput = (_e) =>{
 return isDdPassengerH5 ? ['data:image/png;base64,' + _e] : _e.target.files;
}

/**
 * @name: bridge打开相册能力
 * @param {*} id
 */
const openPhoto = async () => {
  return new Promise((resolve, reject) => {
    try {
      bridge.photograph &&
        bridge.photograph(
          {
            type: 'choice',
            // cut: 'true',
            ext: 'png',
            quality: 100
          },
          res => {
            res.photograph_result === -1 &&
              mpx.showToast({
                icon: 'none',
                title: '请打开系统授权后继续操作'
              });
            resolve(res);
          }
        );
    } catch (err) {
      reject(err)
    }
  })
}

export default choose;
